import { useDispatch, useSelector } from "react-redux";

// Actions
import {
  selectRoadStretch,
  unselectRoadStretch,
} from "../../actions/campaign-planning/CampaignPlanningRoadStretchesActions";

// Components
import Spinner from "../../../components/spinner/Spinner";

// Util Components
export function LoadingRoadStretches() {
  return (
    <div className="d-flex justify-content-center p-2 bg-alt border">
      <Spinner />
      <span className="ml-2 py-1">
        Please wait, Road Stretches are Loading...
      </span>
    </div>
  );
}

export function DataLoading({
  className = "p-2 bg-alt border",
  spinnerClassName = "",
  dataType = "",
}) {
  return (
    <div
      className={`d-flex justify-content-center align-items-center ${className}`}
    >
      <Spinner className={spinnerClassName} />
      <span className="pl-2">{dataType} Loading ...</span>
    </div>
  );
}

export function LoadingPlanningMapView() {
  return (
    <div className="d-flex justify-content-center p-2">
      <Spinner />
    </div>
  );
}

export function StretchSelectionButton({ stretchInfo = {} }) {
  const dispatch = useDispatch();

  const { id: stretchId } = stretchInfo || {};
  const stretchSelected = useSelector(
    (state) => state.planningRoadStretches.selectedStretches[stretchId]
  );

  const btnClassName = stretchSelected
    ? "added-button btn-outline-success"
    : "add-button btn-outline-primary";

  function handleOnClick() {
    if (stretchSelected) {
      dispatch(unselectRoadStretch(stretchSelected));
    } else {
      dispatch(selectRoadStretch(stretchInfo));
    }
  }

  return (
    <button
      type="button"
      className={`btn shadow-none ${btnClassName}`}
      onClick={handleOnClick}
    >
      {stretchSelected ? (
        <>
          <i className="fa fa-check"></i> <b>Selected</b>
        </>
      ) : (
        <b>Select</b>
      )}
    </button>
  );
}

// Planning Header With Action Button
export function HeaderWithActionButton({
  title,
  buttonText,
  onButtonClick = () => {},
  disabled = false,
  buttonLoading = false,
  showButton = true,
}) {
  return (
    <>
      <div className="d-flex justify-content-between p-0">
        <h2 className="mb-0">{title}</h2>
        {showButton && (
          <button
            type="button"
            className="btn btn-primary px-3 rounded-lg shadow-none"
            onClick={onButtonClick}
            disabled={disabled || buttonLoading}
          >
            <span>{buttonText}</span>
            {buttonLoading && (
              <Spinner className="spinner-border-sm ml-2 text-light" />
            )}
          </button>
        )}
      </div>
      <hr className="my-3" />
    </>
  );
}
